import { useInfiniteQuery } from "hooks/useInfiniteQuery";

import { getPortfolios } from "../service";

export const useConnectedAccounts = () => {
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["connectedAccounts"],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        size: 30,
        order: "desc",
      };

      const response = await getPortfolios(params);
      return {
        data: response.data,
        currentPage: response.page,
        totalPages: response.total_pages,
        totalCount: response.total_count,
      };
    },
    getNextPageParam: (lastPage) => {
      const currentPage = Number(lastPage.currentPage);
      const totalPages = Number(lastPage.totalPages);
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
  });

  const allPortfolios = data?.pages?.flatMap((page) => page.data) || [];
  const latestPage = data?.pages?.[data.pages.length - 1];
  const totalPages = latestPage?.totalPages || 0;
  const totalCount = latestPage?.totalCount || 0;
  const currentPage = latestPage?.currentPage || 1;

  return {
    portfolios: allPortfolios,
    totalPages,
    totalCount,
    currentPage,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    refetch,
    fetchNextPage,
  };
};
